import { render, staticRenderFns } from "./FormNumberInput.vue?vue&type=template&id=99bca70a&scoped=true"
import script from "./FormNumberInput.vue?vue&type=script&lang=ts"
export * from "./FormNumberInput.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "99bca70a",
  null
  ,true
)

export default component.exports